import axios from 'axios';
import React, { useEffect, useState } from 'react';

function MyOrders() {
  const [orders, setOrders] = useState([]);
const userId=localStorage.getItem('userId');

  useEffect(() => {
    axios.get(`api/onlinestore/myorders/${userId}`)
      .then(res => {
        
        setOrders(res.data);
      })
      .catch(err => {
        console.error('Error fetching orders:', err);
      });
  }, [userId]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Order List</h1>
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="py-2 px-4 border-b">ID</th>
            <th className="py-2 px-4 border-b">Customer</th>
            <th className="py-2 px-4 border-b">Manual Date</th>
            <th className="py-2 px-4 border-b">Status</th>
            <th className="py-2 px-4 border-b">Created At</th>
         
            <th className="py-2 px-4 border-b">Delivery Date</th>
          </tr>
        </thead>
        <tbody>
          {orders.map(order => (
            <tr key={order.id} className="hover:bg-gray-50">
              <td className="py-2 px-4 border-b text-center">{order.id}</td>
              <td className="py-2 px-4 border-b text-center">{order.username}</td>
              <td className="py-2 px-4 border-b text-center">{order.manualdate}</td>
              <td className="py-2 px-4 border-b text-center">{order.status==='2'?'Pending':'Shipped'}</td>
              <td className="py-2 px-4 border-b text-center">{new Date(order.created_at).toLocaleString()}</td>
    
              <td className="py-2 px-4 border-b text-center">{order.delivery_date}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default MyOrders;